import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const buildSubflowsGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

import { data } from '@/store/modules/workflows/getters';

import WorkflowService from '@/utils/WorkflowService';

import { rootNodeTestResult } from '@/store/modules/workflows/getters';

// getters declarations
export const subflows = buildSubflowsGetterObject('subflows');
export const projectSubflows = buildSubflowsGetterObject('projectSubflows');
export const getSubflowParams = buildSubflowsGetterObject('getSubflowParams');
export const getSubflowInputParams = buildSubflowsGetterObject('getSubflowInputParams');
export const isUpdatingSubflowParams = buildSubflowsGetterObject('isUpdatingSubflowParams');
export const subflowIdFromNode = buildSubflowsGetterObject('subflowIdFromNode');
export const getSubflowInputFields = buildSubflowsGetterObject('getSubflowInputFields');

const getters = {
	[subflows.getter]: (state, getters, rootState, rootGetters) => {
		const workflows = rootGetters[data.fullPath];
		const onlySubflowsKeys = Object.keys(workflows).filter((wfKey) => WorkflowService.isOfTypeSubFlow(workflows[wfKey]));
		return onlySubflowsKeys.map((wfKey) => workflows[wfKey]);
	},
	[projectSubflows.getter]: (state, getters) => (projectId) => {
		const currentSubflows = getters[subflows.getter];
		return currentSubflows.filter((subflow) => subflow.project === projectId);
	},
	[getSubflowParams.getter]: (state) => (inputOutputConfiguration) => state.subflowParams[inputOutputConfiguration] || [],
	[getSubflowInputParams.getter]: (state, getters, rootState, rootGetters) => (subflowId) => {
		const workflows = rootGetters[data.fullPath];
		const workflow = workflows[subflowId];
		return state.subflowParams[workflow.current_draft.sub_flow_input_configuration];
	},
	[isUpdatingSubflowParams.getter]: (state) => state.isUpdatingSubflowParams,
	[subflowIdFromNode.getter]: () => (node) => node.params_map?.['sub_flow_id'],
	[getSubflowInputFields.getter]: (state, getters, rootState, rootGetters) => (workflowId) => {
		const subflowInputParams = getters[getSubflowInputParams.getter](workflowId) || [];
		const inputParamsUuids = subflowInputParams.map(({ uuid }) => uuid);
		const allFields = rootGetters[rootNodeTestResult.fullPath](workflowId);
		const mappedFields = Object.keys(allFields).reduce(
			(result, fieldKey) => (inputParamsUuids.includes(fieldKey) ? { ...result, [fieldKey]: allFields[fieldKey] } : result),
			{}
		);
		return mappedFields;
	},
};

export default getters;
